import { axios } from "@axios";
import { useQuery, useMutation } from "react-query";
import {
  ExtractFnReturnType,
  MutationConfig,
  QueryConfig,
} from "../../lib/react-query";

export const getAllTransactions = (userId: string, params: any): Promise<any> => {
  return axios.get(`/transaction/get-all-transactions/${userId}`, { params });
};

type GetAllOffersQueryFnType = typeof getAllTransactions;

export const useAllTransactionsQuery = (
  userId: string,
  params: any,
  config?: QueryConfig<GetAllOffersQueryFnType>
) => {
  return useQuery<ExtractFnReturnType<GetAllOffersQueryFnType>>({
    queryKey: ["allTransactions", userId, params],
    queryFn: () => getAllTransactions(userId, params),
    select: (res: any) => res.data,
    ...config,
  });
};



export const getWallet = async (userId: string, params: any): Promise<any> => {
  try {
    const response = await axios.get(`/transaction/get-wallet/${userId}`, { params });
    return response;
  } catch (error: any) {
    const message = error?.response?.data?.message || "Failed to fetch wallet";
    throw new Error(message);
  }
};

type GetAllWalletQueryFnType = typeof getWallet;

export const useGetWalletQuery = (
  userId: string,
  params: any,
  config?: QueryConfig<GetAllWalletQueryFnType>
) => {
  return useQuery<ExtractFnReturnType<GetAllWalletQueryFnType>>({
    queryKey: ["wallet", userId, params], // ✅ Unique query key
    queryFn: () => getWallet(userId, params), // ✅ Correct query function
    select: (res: any) => res.data,
    ...config,
  });
};
